import {
  Backdrop,
  Box,
  CircularProgress,
  Grid,
  IconButton,
  ListItem,
  Menu,
  MenuItem,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { CiFileOn } from "react-icons/ci";
import { IoIosArrowDown } from "react-icons/io";
import { Enumerations } from "../../config/Enumerations";
import { AppEntryDocRepository } from "../repositories/AppEntryDocRepository";
import { GoEye } from "react-icons/go";
import { FiDownload } from "react-icons/fi";
import { TfiMoreAlt } from "react-icons/tfi";
import InfoAlert from "../common/InfoAlert";
import PDFDialogViewer from "../entries/PDFDialogViewer";
import {
  Download,
  DownloadForOffline,
  DownloadOutlined,
  Preview,
  PreviewOutlined,
  PreviewSharp,
} from "@mui/icons-material";

const options = [
  { key: "preview", label: "Преглед", icon: <GoEye size={18} /> },
  { key: "download", label: "Преземи", icon: <FiDownload size={18} /> },
];

export default function ReviewRequests({ appReview }) {
  const theme = useTheme();
  const [documents, setDocuments] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [openPdfDialog, setOpenPdfDialog] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [menuOptions, setMenuOptions] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getAll();
  }, []);

  const getAll = () => {
    AppEntryDocRepository.getAll(appReview?.appEntry?.id)
      .then((res) => {
        console.log(res.data);
        setDocuments(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getByFileName = (fileName) => {
    AppEntryDocRepository.getDocument(appReview?.appEntry?.id, fileName, {
      responseType: "blob",
    })
      .then((res) => {
        setPdfBlob(res.data);
        setOpenPdfDialog(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleMenuClick = (event, fileName) => {
    setMenuAnchor(event.currentTarget);
    setSelectedFile(fileName);

    const filtered = options.filter((option) => {
      if (fileName.includes("-signed") && option.key === "sign") {
        return false;
      }
      return true;
    });
    setMenuOptions(filtered);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setSelectedFile(null);
  };

  const downloadByFileName = (fileName) => {
    setSaving(true);
    AppEntryDocRepository.getDocument(appReview?.appEntry?.id, fileName, {
      responseType: "blob",
    })
      .then((res) => {
        setSaving(false);
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        setSaving(false);
        console.log(err);
      });
  };

  return (
    <React.Fragment>
      <Grid item xs={12} className="other-documents-container" sx={{ mt: 2 }}>
        <div className="other-documents-header no-bottom-padding">
          <div className="other-documents-title-container">
            <div className="other-documents-title">
              <Typography variant="h6" className="title-text">
                Барања за согласност
              </Typography>
            </div>
          </div>
        </div>
        {documents?.filter(
          (doc) =>
            doc.documentType === "TRAFFIC_CHANGE_REQUEST" ||
            doc.documentType === "REQ_CANCELLATION_DOC",
        ).length > 0 ? (
          <Box className="other-documents-box">
            {documents
              ?.filter(
                (doc) =>
                  doc.documentType === "TRAFFIC_CHANGE_REQUEST" ||
                  doc.documentType === "REQ_CANCELLATION_DOC",
              )
              .map((doc, index) => (
                <ListItem key={index} className="document-item dark-border">
                  <div className="document-icon">
                    <CiFileOn color="#2d2d2d" size={25} />
                  </div>
                  <div className="document-details">
                    <Typography
                      variant="inherit"
                      className="document-name dark"
                    >
                      {Enumerations.DocumentType[doc.documentType] ||
                        doc.documentType}
                    </Typography>
                  </div>
                  <div className="document-actions">
                    <IconButton onClick={() => getByFileName(doc.fileName)}>
                      <PreviewSharp
                        size={20}
                        color={theme.palette.secondary.main}
                      />
                    </IconButton>
                    <IconButton
                      onClick={() => downloadByFileName(doc.fileName)}
                    >
                      <DownloadOutlined
                        size={20}
                        color={theme.palette.secondary.main}
                      />
                    </IconButton>
                  </div>
                </ListItem>
              ))}
          </Box>
        ) : (
          documents?.filter(
            (doc) =>
              doc.documentType === "TRAFFIC_CHANGE_REQUEST" ||
              doc.documentType === "REQ_CANCELLATION_DOC",
          ).length === 0 && (
            <div style={{ padding: "10px 0" }}>
              <InfoAlert message="Нема барања за согласност." />
            </div>
          )
        )}
      </Grid>
      <PDFDialogViewer
        openPdfDialog={openPdfDialog}
        setOpenPdfDialog={setOpenPdfDialog}
        pdfBlob={pdfBlob}
      />
      {saving && (
        <Backdrop open={true} sx={{ zIndex: 9999, color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </React.Fragment>
  );
}
